import { getRelatedCourses } from "@/actions/courses";
import { getQuizSummary } from '@/actions/quizAction';
import Loader from '@/components/common/Spinner';
import CustomCourseCarousel from '@/components/CustomCourseCarousel';
import {
  capitalizeFirstLetter,
  generateStrokeColor,
  imagesLink,
} from '@/helpers/dataHelper';
import useWidth, { IBooleanArgs } from '@/helpers/widthUtil';
import { Button, Progress, Skeleton } from 'antd';
import React, { FC, useEffect, useState } from "react";
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import QuizSummary from './quizSumarryModal';
import {
  ClockCircleOutlined,
  LikeOutlined,
  CommentOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import CourseSingleItem from '../course/CourseSingleItem';
import { Dispatch } from 'redux';

const ProfileDashboardComponent: FC<{}> = () => {
  const { isMobile, isDesktopXL }: IBooleanArgs = useWidth();
  const dispatch: Dispatch = useDispatch();
  const profile: object | any = useSelector(
    (state: RootStateOrAny) => state?.auth?.profile?.data
  );
  const getProfileStatus: string = useSelector(
    (state: RootStateOrAny) => state?.auth?.getProfileStatus
  );

  const [visible, setVisible] = useState<boolean>(false);
  const quizSummary: object | any = useSelector(
    (state: RootStateOrAny) => state.quizReducer?.quizSummary
  );

  const viewDetail = (slug: string): void => {
    setVisible(true);
    dispatch(getQuizSummary(slug));
  };
  useEffect(() => {
    dispatch(getRelatedCourses(null, true));
  }, []);
  const { relatedCourses }: object | any = useSelector((state: RootStateOrAny) => ({
    relatedCourses: state?.courses?.relatedCourse,
  }));
  return (
    <>
      <h3 className="text-dark">
        <img
          src={'/images/svgs/dashboard/dashboard stroke.svg'}
          className="mr-3"
          width={'28px'}
          height="28px"
        />
        Dashboard
      </h3>
      <div
        className={`stats row ${
          isDesktopXL ? 'd-flex justify-content-between' : ''
        }`}
      >
        <div
          className={`enrolled-course  card d-flex flex-column bg-light border-14 p-3  ${
            isDesktopXL ? 'col-lg-2' : 'col-lg-3 mr-3'
          } col-md-3 col-sm-12 mt-4`}
        >
          <span className="text-center font-weight-500">Hours Completed</span>
          <h5 className="text-center text-dark font-size-large">
            {getProfileStatus === 'request' ? (
              <Loader className="font-size-large" size={{ width: 48, height: 48 }} />
            ) : (
              profile?.dashboard?.user_course_stat?.hours_completed
            )}
          </h5>
          <div
            className="border-bottom-solid border-secondary mx-auto"
            style={{ width: '120px' }}
          />
        </div>
        <div
          className={`enrolled-course card d-flex flex-column p-3 bg-light border-14 ${
            isDesktopXL ? 'col-lg-2' : 'col-lg-3 mr-3'
          }  col-md-3 col-sm-12 mt-4`}
        >
          <span className="text-center font-weight-500">Enrolled Courses</span>
          <h5 className="text-center text-dark font-size-large">
            {getProfileStatus === 'request' ? (
              <Loader className="font-size-large" size={{ width: 48, height: 48 }} />
            ) : (
              profile?.dashboard?.user_course_stat?.total
            )}
          </h5>
          <div
            className="border-bottom-solid border-warning mx-auto"
            style={{ width: '120px' }}
          />
        </div>
        <div
          className={`enrolled-course card d-flex flex-column p-3 bg-light border-14 ${
            isDesktopXL ? 'col-lg-2' : 'col-lg-3 mr-3'
          } col-md-3 col-sm-12 mt-4`}
        >
          <span className="text-center font-weight-500">Active Courses</span>
          <h5 className="text-center text-dark font-size-large">
            {getProfileStatus === 'request' ? (
              <Loader className="font-size-large" size={{ width: 48, height: 48 }} />
            ) : (
              profile?.dashboard?.user_course_stat?.active
            )}
          </h5>
          <div
            className="border-bottom-solid border-success mx-auto"
            style={{ width: '120px' }}
          />
        </div>
        <div
          className={`enrolled-course card d-flex flex-column p-3 bg-light border-14 ${
            isDesktopXL ? 'col-lg-2' : 'col-lg-3 mr-3'
          } col-md-3 col-sm-12 mt-4`}
        >
          <span className="text-center font-weight-500">Completed Courses</span>
          <h5 className="text-center text-dark font-size-large">
            {getProfileStatus === 'request' ? (
              <Loader className="font-size-large" size={{ width: 48, height: 48 }} />
            ) : (
              profile?.dashboard?.user_course_stat?.completed
            )}
          </h5>
          <div
            className="border-bottom-solid border-primary border-center mx-auto"
            style={{ width: '130px' }}
          />
        </div>
      </div>
      {/* <div className="border-bottom-solid border-secondary d-flex justiy-content-center mt-4" /> */}
      <div className="row">
        <div className="col-lg-6 col-sm-12">
          {profile?.dashboard?.live_class?.id && (
            <div className="mt-5 latest-live-class">
              <>
                <h5 className="text-dark font-size-md text-uppercase">
                  Do not miss our latest live class
                </h5>
                <Skeleton
                  style={{ height: '24px !important' }}
                  loading={getProfileStatus === 'request'}
                >
                  <div className="d-flex">
                    <div
                      className="card border-14 shadow-none mt-3"
                      style={
                        {
                          // background: "#f0f8ff"
                        }
                      }
                    >
                      <div className="card-body">
                        <div className="d-flex">
                          <div
                            className="border-14 pt-1 pb-1 pl-3 pr-3 d-flex justify-content-center align-items-center flex-column"
                            style={{
                              background: '#f0f8ff',
                              // "rgba(25, 86, 156, 0.8)"
                            }}
                          >
                            <h6 className="text-dark text-uppercase">
                              {profile?.dashboard?.live_class?.weekday}
                            </h6>
                            <h5 className="text-dark">
                              {profile?.dashboard?.live_class?.day}
                            </h5>
                          </div>
                          <div className="d-flex flex-column justify-content-between">
                            <div className="d-flex flex-row ml-2">
                              <h6 className="text-black pl-2 pr-2 border-14 d-flex">
                                {profile?.dashboard?.live_class?.name}
                              </h6>
                              {!isMobile && (
                                <h6
                                  className="text-black pl-2 pr-2 border-14 d-flex ml-2"
                                  style={{
                                    background: 'rgba(108, 117,125, 0.4',
                                    // "rgba(108, 117,125, 0.4)"
                                  }}
                                >
                                  <div
                                    className="mr-1 border-18 pl-2 pr-2 pt-1 pb-1 mt-1 mb-1"
                                    style={{
                                      background: 'rgba(0,0,0, 1)',
                                      height: isMobile ? '10px' : 'auto',
                                    }}
                                  />
                                  <span className="font-size-sm my-auto">
                                    {profile?.dashboard?.live_class?.mode}
                                  </span>
                                </h6>
                              )}
                            </div>
                            <div className="d-flex flex-row justify-content-between ml-2">
                              <span className="font-weight-normal pl-2 mr-auto">
                                {profile?.dashboard?.live_class?.start}
                                <i className="fas fa-thin fa-arrow-right font-weight-normal mt-2 ml-1"></i>{' '}
                                {profile?.dashboard?.live_class?.end}
                              </span>
                              <Button
                                size={'small'}
                                type="text"
                                className="border-14 border-0 pl-2 pr-2 montserrat-font-family"
                                href={profile?.dashboard?.live_class?.url}
                                target="_blank"
                              >
                                Join{' '}
                                <i className="fas fa-thin text-dark fa-arrow-right font-weight-normal mt-2 ml-1"></i>
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Skeleton>
              </>
            </div>
          )}
        </div>

        <div className={`col-lg-6 col-sm-12 mt-5 ${!isMobile ? 'border-left' : ''}`}>
          {profile?.dashboard?.latest_discussion_post?.length !== 0 && (
            <>
              <div className="d-flex mb-2 justify-content-between align-items-center">
                <h5 className="text-dark font-size-md text-uppercase">
                  Recent post from you
                </h5>
              </div>
              <Skeleton
                style={{ height: '24px !important' }}
                loading={getProfileStatus === 'request'}
              >
                {profile?.dashboard?.latest_discussion_post?.map((each) => (
                  <a href={`/room/${each?.room__slug}?discussion=${each?.id}`}>
                    <div
                      className="card border-14 shadow-none"
                      key={each?.id}
                      style={
                        {
                          // background: "#f0f8ff"
                        }
                      }
                    >
                      <div className="card-body">
                        <div className="row">
                          {each?.image && (
                            <div className="col-xl-2 col-lg-2 col-md-2 p-0">
                              <img
                                src={each?.image}
                                className="rounded my-auto"
                                alt={each?.room__name}
                                style={{ width: '100px', height: '75px' }}
                              />
                            </div>
                          )}
                          <div
                            className={
                              each?.image
                                ? 'col-xl-10 col-lg-10 col-md-10'
                                : 'col-xl-12 col-lg-12 col-md-12'
                            }
                          >
                            <div className="d-flex flex-column">
                              <p
                                className="text-dark font-weight-bold mb-0"
                                style={{ fontSize: '12px' }}
                              >
                                {each?.text}...
                              </p>
                              <div className="d-flex flex-row justify-content-between font-weight-normal">
                                <div className="d-flex text-dark flex-row justify-content-start font-weight-normal">
                                  <span>
                                    <ClockCircleOutlined className="mr-1" />
                                  </span>
                                  <span style={{ marginTop: '3px' }}>
                                    {moment(each.created_at).fromNow()}
                                  </span>
                                </div>
                                <div className="d-flex justify-content-between">
                                  <div className="d-flex text-dark flex-row justify-content-end font-weight-normal">
                                    <span>
                                      <LikeOutlined className="mr-1" />
                                    </span>
                                    <span style={{ marginTop: '3px' }}>
                                      {each?.like}
                                    </span>
                                  </div>
                                  <div className="d-flex text-dark flex-row justify-content-end font-weight-normal ml-2">
                                    <span>
                                      <CommentOutlined className="mr-1" />
                                    </span>
                                    <span style={{ marginTop: '3px' }}>
                                      {each?.comment}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* <div dangerouslySetInnerHTML={each?.text} /> */}
                        </div>
                      </div>
                    </div>
                  </a>
                ))}
              </Skeleton>
            </>
          )}
        </div>
      </div>
      {
        // (profile?.dashboard?.last_content?.id || profile?.dashboard?.user_learnings?.length !== 0) &&
        <div className="row mb-4">
          {profile?.dashboard?.last_content?.id && (
            <div className="col-lg-6 mt-5 col-sm-12">
              <h5 className="text-dark mb-4 font-size-md text-uppercase">
                Continue Watching
              </h5>
              {profile?.dashboard?.last_content?.course__slug && (
                <a
                  href={
                    getProfileStatus !== 'request'
                      ? `/course/lesson/${profile?.dashboard?.last_content?.course__slug}`
                      : ''
                  }
                >
                  <div className="card bg-transparent border-0 shadow-none mt-3">
                    {getProfileStatus === 'request' ? (
                      <Skeleton.Image
                        className="mx-auto"
                        style={{ height: '150px', width: '300px' }}
                      />
                    ) : (
                      <div className="col">
                        <div className="text-center">
                          <img
                            className="rounded border-0 card-img-top text-center"
                            style={{ height: '150px', width: '300px' }}
                            src={profile?.dashboard?.last_content?.course__image}
                          />
                        </div>
                        <div className="course-preview-play bg-white">
                          <i
                            className="fas fa-play-circle"
                            style={{ color: 'rgba(0, 0, 0,0.5)' }}
                          ></i>
                        </div>
                      </div>
                    )}
                    <div className="card-body d-flex">
                      {/* {
                                            getProfileStatus === "request" ?

                                                <Skeleton.Image style={{ width: '80px', height: '50px' }} />
                                                : <img className="rounded border-0" width={"80px"} style={{ height: '50px' }} src={profile?.dashboard?.last_content?.course__image} />
                                        } */}
                      <div className="col d-flex flex-column">
                        {getProfileStatus === 'request' ? (
                          <div className="d-flex">
                            <Skeleton.Button className="mx-auto d-block" />
                            <Skeleton.Button className="mx-auto d-block" />
                            <Skeleton.Button className="mx-auto d-block" />
                          </div>
                        ) : (
                          <h6
                            className="font-size-small text-black"
                            style={{ fontWeight: '500' }}
                          >
                            {capitalizeFirstLetter(
                              profile?.dashboard?.last_content?.course__name
                            )}
                          </h6>
                        )}
                        {getProfileStatus !== 'request' && (
                          <span>
                            Last content you viewed:{' '}
                            {capitalizeFirstLetter(
                              profile?.dashboard?.last_content?.name
                            )}
                          </span>
                        )}
                        {/* <video src={profile?.dashboard?.last_content?.video} /> */}
                      </div>
                      {getProfileStatus === 'request' ? (
                        <Loader
                          className="font-size-large"
                          size={{ width: 48, height: 48 }}
                        />
                      ) : (
                        <Progress
                          type="circle"
                          strokeColor={generateStrokeColor(
                            parseInt(
                              profile?.dashboard?.last_content?.enroll_percentage
                            )
                          )}
                          percent={
                            profile?.dashboard?.last_content?.enroll_percentage
                          }
                          width={48}
                        />
                      )}
                    </div>
                  </div>
                </a>
              )}

              {/* :
                                <Empty /> */}
            </div>
          )}
          {
            // profile?.dashboard?.user_learnings?.length !== 0 &&
            <div
              className={`col-lg-6 mt-5 col-sm-12 ${
                !isMobile && profile?.dashboard?.last_content?.course__slug
                  ? 'border-left'
                  : ''
              }`}
            >
              <div className="d-flex mb-4 justify-content-between align-items-center">
                <h5 className="text-dark my-auto font-size-md text-uppercase">
                  My Learnings
                </h5>
                <Button
                  size={'middle'}
                  className="btn-danger text-white border-14 border-danger btn-sm pl-2 pr-2 montserrat-font-family"
                  href="/profile/my-course"
                >
                  View all Learnings <i className="fas fa-arrow-right ml-1"></i>
                </Button>
              </div>
              {
                profile?.dashboard?.user_learnings?.map((each) => (
                  <a
                    href={
                      getProfileStatus !== 'request'
                        ? `/course/lesson/${each?.slug}`
                        : ''
                    }
                  >
                    <div
                      className="card bg-transparent border-0 shadow-none mt-3"
                      key={each?.id}
                    >
                      <div className="card-body d-flex">
                        {getProfileStatus === 'request' ? (
                          <Skeleton.Image
                            style={{ width: '80px', height: '50px' }}
                          />
                        ) : (
                          <img
                            className="rounded border-0"
                            width={'80px'}
                            style={{ height: '50px' }}
                            src={
                              each?.image
                                ? each?.image
                                : imagesLink[
                                    Math.floor(Math.random() * imagesLink.length)
                                  ]
                            }
                          />
                        )}
                        <div className="col d-flex flex-column">
                          {getProfileStatus === 'request' ? (
                            <Skeleton.Button className="mt-1" />
                          ) : (
                            <h6
                              className="font-size-small text-black"
                              style={{ fontWeight: '500' }}
                            >
                              {capitalizeFirstLetter(each?.name)}
                            </h6>
                          )}
                          {getProfileStatus !== 'request' &&
                            each?.last_content?.name && (
                              <span>
                                Last watched content:{' '}
                                {capitalizeFirstLetter(each?.last_content?.name)}
                              </span>
                            )}
                          {/* <video src={profile?.dashboard?.last_content?.video} /> */}
                        </div>
                        {getProfileStatus === 'request' ? (
                          <Loader
                            className="font-size-large"
                            size={{ width: 48, height: 48 }}
                          />
                        ) : (
                          <Progress
                            strokeColor={generateStrokeColor(
                              parseInt(each?.enroll_percentage)
                            )}
                            type="circle"
                            percent={each?.enroll_percentage}
                            width={48}
                          />
                        )}
                      </div>
                    </div>
                  </a>
                ))
                // :
                // <Empty />
              }
            </div>
          }
        </div>
      }
      {(profile?.dashboard?.latest_quiz?.length !== 0 ||
        profile?.dashboard?.latest_mocktest?.length !== 0) && (
        <div className="row mt-5 mb-4">
          {profile?.dashboard?.latest_quiz?.length !== 0 && (
            <div className="col-lg-6 col-sm-12">
              <div className="d-flex mb-4 justify-content-between align-items-center">
                <h5 className="text-dark font-size-md text-uppercase">
                  Latest Quiz you Attemped
                </h5>
                <Button
                  size={'middle'}
                  className="btn-danger text-white border-14 border-danger btn-sm pl-2 pr-2 montserrat-font-family"
                  href="/profile/quiz"
                >
                  View all Quizzes <i className="fas fa-arrow-right ml-1"></i>
                </Button>
              </div>
              {
                profile?.dashboard?.latest_quiz?.map((each) => (
                  <div
                    className="card bg-transparent border-0 shadow-none mt-3"
                    key={each?.id}
                  >
                    <div className="card-body d-flex flex-nowrap">
                      {getProfileStatus === 'request' ? (
                        <Skeleton.Image style={{ width: '80px', height: '50px' }} />
                      ) : (
                        <img
                          className="rounded border-0"
                          width={'80px'}
                          style={{ height: '50px' }}
                          src={
                            each?.image
                              ? each?.image
                              : imagesLink[
                                  Math.floor(Math.random() * imagesLink.length)
                                ]
                          }
                        />
                      )}
                      <div className="col d-flex flex-column flex-nowrap">
                        {getProfileStatus === 'request' ? (
                          <Skeleton.Button className="mt-1" />
                        ) : (
                          <h6
                            className="font-size-small text-black"
                            style={{ fontWeight: '500' }}
                          >
                            {capitalizeFirstLetter(each?.course)}
                          </h6>
                        )}
                        {getProfileStatus !== 'request' && each?.chapter && (
                          <span>
                            Chapter: {capitalizeFirstLetter(each?.chapter)}
                          </span>
                        )}
                      </div>
                      <div className="d-flex row flex-nowrap flex-row justify-content-end align-items-center">
                        {each?.total && (
                          <div className="col">
                            {each?.correct}/{each?.total}
                          </div>
                        )}
                        {!isMobile && (
                          <div className="col">
                            {getProfileStatus === 'request' ? (
                              <Loader
                                className="font-size-large"
                                size={{ width: 48, height: 48 }}
                              />
                            ) : parseInt(each?.percentage) === 100 ? (
                              <img
                                src="/images/check.svg"
                                width={'28px'}
                                height="28px"
                              />
                            ) : (
                              <Progress
                                style={{ width: '28px' }}
                                // strokeWidth={"28px" as any}
                                strokeColor={generateStrokeColor(
                                  parseInt(each?.percentage)
                                )}
                                type="circle"
                                percent={each?.percentage}
                                width={48}
                              />
                            )}
                          </div>
                        )}
                        <div className="col">
                          <Button
                            type="text"
                            size="small"
                            className="btn-outline-primary text-white border-14 montserrat-font-family ml-2"
                            onClick={() => viewDetail(each?.slug)}
                          >
                            <span className="d-flex justify-content-between">
                              View{' '}
                              <i className="fas fa-eye float-right ml-1 my-auto"></i>
                            </span>
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
                // :
                // <Empty />
              }
            </div>
          )}
          {profile?.dashboard?.latest_mocktest?.length !== 0 && (
            <div className={`col-lg-6 col-sm-12 ${!isMobile ? 'border-left' : ''}`}>
              <div className="d-flex mb-4 justify-content-between align-items-center">
                <h5 className="text-dark font-size-md text-uppercase">
                  Latest MockTest Attemped
                </h5>
                <Button
                  size={'middle'}
                  className="btn-danger text-white border-14 border-danger btn-sm pl-2 pr-2 montserrat-font-family"
                  href="/mock-test"
                >
                  View all Mocktest <i className="fas fa-arrow-right ml-1"></i>
                </Button>
              </div>
              {
                // profile?.dashboard?.latest_mocktest?.length !== 0 ?
                profile?.dashboard?.latest_mocktest?.map((each) => (
                  <div
                    className="card bg-transparent border-0 shadow-none mt-3"
                    key={each?.model__id}
                  >
                    <div className="card-body d-flex">
                      {getProfileStatus === 'request' ? (
                        <Skeleton.Image style={{ width: '80px', height: '50px' }} />
                      ) : (
                        <img
                          className="rounded border-0"
                          width={'80px'}
                          style={{ height: '50px' }}
                          src={
                            each?.course__image
                              ? each?.course__image
                              : imagesLink[
                                  Math.floor(Math.random() * imagesLink.length)
                                ]
                          }
                        />
                      )}
                      <div className="col d-flex flex-column">
                        {getProfileStatus === 'request' ? (
                          <Skeleton.Button className="mt-1" />
                        ) : (
                          <h6
                            className="font-size-small text-black"
                            style={{ fontWeight: '500' }}
                          >
                            {capitalizeFirstLetter(each?.model__name)}
                          </h6>
                        )}
                        {getProfileStatus !== 'request' && each?.course__name && (
                          <span>
                            Course: {capitalizeFirstLetter(each?.course__name)}
                          </span>
                        )}
                      </div>
                      <div className="d-flex row flex-row justify-content-end align-items-center">
                        <div className="col">
                          <Button
                            type="text"
                            size="small"
                            className="btn-outline-primary text-white border-14 montserrat-font-family ml-2"
                            href={`/mock-test/reports/${each?.model__slug}`}
                          >
                            <span className="d-flex justify-content-between">
                              View{' '}
                              <i className="fas fa-eye float-right ml-1 my-auto"></i>
                            </span>
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
                // :
                // <Empty />
              }
            </div>
          )}
        </div>
      )}
      {!relatedCourses?.loading && (
        <div className="mt-5 mb-5">
          <h5 className="text-dark font-size-md text-uppercase">
            Recommended for you
          </h5>
          <div className="row">
            {relatedCourses?.data?.length <= 3 && !isMobile ? (
              relatedCourses?.data?.map((course) => (
                <div className="col-4">
                  <CourseSingleItem isCarousel={false} course={course} />
                </div>
              ))
            ) : (
              <CustomCourseCarousel courses={relatedCourses?.data} relatedCourses />
            )}
          </div>
        </div>
      )}
      <QuizSummary
        quizDetail={quizSummary}
        visible={visible}
        cancel={() => setVisible(false)}
      />
    </>
  );
};

export default ProfileDashboardComponent;